import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Canceled from '../views/Canceled.vue'
import Success from '../views/Success.vue'

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/play",
    name: "",
    component: () => import(/* webpackChunkName: "play" */ '../views/Play.vue'),
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/canceled",
    name: "Canceled",
    component: Canceled,
  },
  {
    path: "/success",
    name: "Success",
    component: Success,
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
